export function vistaAptos() {
    return [{
        "Nombre": "3",
    },
    {
        "Nombre": "4",
    },
    {
        "Nombre": "5",
    },
    {
        "Nombre": "6",
    },
    {
        "Nombre": "7",
    },
    {
        "Nombre": "8",
    },
    {
        "Nombre": "9",
    },
    {
        "Nombre": "10",
    },
    {
        "Nombre": "11",
    },
    ]
}
